var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-vc"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"review-vc",on:{"click":function($event){return _vm.downLoad()}}},[_vm._v("点击预览附件简历")])])
}
var staticRenderFns = []

export { render, staticRenderFns }